var base = require('settings/teams/team-members');

Vue.component('spark-team-members', {
    mixins: [base],
    methods: {
        makeOwner(user) {
            const _this = this;
            swalc(['Are you sure?', 'After changing owner, only the new owner can change back.'], (confirm) => {
                if (confirm) {
                    axios.put(`/api/teams/${this.team.id}/owner/${user.id}`).then((response) => {
                        window.location.reload();
                    });
                }
            });
        },
    },
});
